import { CommandInput } from 'cmdk';
import type { LucideIcon } from 'lucide-react';
import * as React from 'react';
import { Command, CommandGroup, CommandItem, CommandList } from './shadcn/Command';
import { Popover, PopoverContent, PopoverTrigger } from './shadcn/Popover';

interface PopCommandsProps {
  options: {
    key: string;
    label: string | React.ReactNode;
    onClick?: () => void;
    icon?: LucideIcon;
    iconClassName?: string;
  }[];
  trigger: (trigger: () => void) => React.ReactNode;
}

export function PopCommands(props: PopCommandsProps) {
  const { options, trigger } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>{trigger(() => setOpen(true))}</PopoverTrigger>
      <PopoverContent className="p-0 w-fit" side="right" align="start">
        <Command shouldFilter={false} autoFocus>
          {/* Hidden input to get focus to enable keyboard navigation */}
          <CommandInput className="h-0" />
          <CommandList>
            <CommandGroup>
              {options.map((option) => (
                <CommandItem
                  key={option.key}
                  onSelect={() => {
                    setOpen(false);
                    option.onClick?.();
                  }}
                >
                  <div className="flex items-center gap-2">
                    {option.icon && (
                      <option.icon className={`size-4 ${option.iconClassName ?? ''}`} />
                    )}
                    {typeof option.label === 'string' ? <span>{option.label}</span> : option.label}
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
